export default __webpack_public_path__ + "images/kai-edit-profile.svg";